export interface IApiResponse {
  message: string
  status: boolean
  status_code: number
  data: any
}

export interface IPagination {
  totalDocs: number;
  limit: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNext_page: boolean;
  prevPage: any;
  nextPage: any;

}

export interface EmailPreference {
  key: string; // Unique identifier for the preference
  name: string; // Display name for the preference
  value: boolean; // Indicates whether the preference is enabled
  description: string; // Description of the preference
}

export interface UserPreferencesPayload {
  user_id: string; // User's unique identifier
  preferences: EmailPreference[]; // Array of email preferences
}

export enum MethodTypes {
  REQ_LOAN = 'Requested loan',
  UPDATE_LOAN = 'Updated loan request',
  ACCEPT_LOAN = 'Accepted loan',
  COUNTER_OFFER = 'Counter offered',
  RECOUNT_OFFER = 'Recounter offered',
  BORROW_RECOUNT_OFFER = 'Borrower recounter offered',
  CANCEL_LOAN = 'Cancelled loan',
  CREATE_SELL_ORDER = 'Created sell order',
  CANCEL_SELL_ORDER = 'Cancelled sell order',
  PURCHASE_SELL_ORDER = 'Purchased sell order',
  PURCHASE_PARTNER_ITEM = 'Purchased partner item',
  LOAN_REPAID = 'Loan repaid',
  FORECLOSE_LOAN = 'Foreclosed loan',
  SIGNUP = 'Signup',
  USER_BLOCK = 'User blocked',
  USER_UNBLOCK = 'User unblocked',
  UPDATE_USER = 'Updated user',
  DELETE_USER = 'Deleted user',
  ITEM_TRANSFER = 'Item transferred',
  CREATE_ITEMBID = 'Created item bid',
  EDIT_ITEMBID = 'Edited item bid',
  CANCEL_ITEMBID = 'Cancelled item bid',
  ACCEPT_ITEMBID = 'Accepted item bid',
  ITEM_MINTED = 'Item minted',
  PARTNER_COL_CREATED = 'Partner collection created',
  PARTNER_ITEM_CREATED = 'Partner item created',
  BURN_ITEM = 'Burned item',
  EMAIL_VERIFY = 'Email verified',
  GOOGLE_AUTH = 'Google auth',
  APPLY_AUTH = 'Apple auth',
  LOAN_DEFAULT = 'Loan defaulted',
  CREATE_ITEM_LOAN_BID = 'Created item loan bid',
  EDIT_ITEM_LOAN_BID = 'Edited item loan bid',
  ACCEPT_ITEM_LOAN_BID = 'Accepted item loan bid',
  CANCEL_ITEM_LOAN_BID = 'Cancelled item loan bid',
  BULK_MINT = 'Bulk minted',
  COUNTER_OFFER_OPEN_LOAN_BID = "Counter offered open loan bid",
  CREATE_BULK_LOAN_BID = "Created bulk loan bid",
  ACCEPT_BULK_LOAN_BID = "Accepted bulk loan bid",
  CANCEL_BULK_LOAN_BID = "Cancelled bulk loan bid",
  EDIT_BULK_LOAN_BID = "Edited bulk loan bid",
  SELL_ORDER_CREATED = "Sell order created"
}

export const PRECIOUS_METAL_CATEGORY = ['gold', 'silver', 'platinum', 'palladium']